export enum ResponseCode {
  SUCCESS = 201,
  UNAUTHORIZED = 401,
  NOT_FOUND = 404,
  INTERVAL_SERVER = 500,
  FORBIDDEN = 403,
  ERR_BAD_REQUEST = 400,
}
